import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { LinesWithBreaks } from "./LinesWithBreaks.js";
export const TextWithBreaks = ({ text }) => !text ? _jsx(_Fragment, {}) : _jsx(LinesWithBreaks, { lines: text.trim().split("\n") });
//# sourceMappingURL=TextWithBreaks.js.map